module.exports = __webpack_public_path__ + "readmeTemplates/OSH_disposal.e320cd104f0c912519b0978630e16565.md";